import React from 'react';
import axios from 'axios';

const AddTaskAPICall = async (data, onSuccess, onError)=>{
    try{
        const res = await axios.post("/add/task", data, {
            headers: {
                "Content-Type": "application/json"
            },
            withCredentials: true,
            // baseURL: "https://shielded-lowlands-66092.herokuapp.com/"
            baseURL: "https://salty-reaches-69347.herokuapp.com/"
        });
        console.log(res.data.status);
        onSuccess && onSuccess(res);
    }
    catch(err){
        console.log(err);
        onError && onError(err);
    }
};

export default AddTaskAPICall;